import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTable from "../components/useTable"
import Controls from "../components/controls/Controls";
import { Dimmer } from '../components/spinner';


import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

    ;

import axios from "axios";


const CatalogoContable = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'))


    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [recordsd, setRecordsd] = useState([]);
    const [values, setValues] = useState({});
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);

    const headCells = [
        { id: 'cuenta', label: 'CODIGO', width: '100px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: 'descripcion', label: 'DESCRIPCION', width: '300px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
        { id: 'id', label: 'ID', width: '80px', textAlign: "center", backgroundColor: "rgb(5, 81, 130)", fontSize: "10px", color: "white" },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.codigocuenta.includes(target.value)
                            || x.descripcion.toLowerCase().includes(target.value.toLowerCase())
                            || x.idcuentacontable.toString().includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);

        var idcuentacontable = recordsAfterPagingAndSorting()[index].idcuentacontable;


        var datos = [];

        datos.push({
            idcuentacontable,


        })
        setValues(datos);
    };

    const seleccionarLista = (index) => (event) => {


        blanquear();
        props.onHideAcepta(values[0].idcuentacontable);


    };


    const seleccionarCuentaContable = () => {

        let endpoint

        if (parseInt(props.llamado) === 1) {

            endpoint = `${op.conexion}/api/contabilidadfis/catalogocontable3?efiscal=${idefiscal}&carga=${"true"}`;

        } else {

            endpoint = `${op.conexion}/api/contabilidadfis/catalogocontable1?efiscal=${idefiscal}`;

        }

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            }
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                console.log(response.data)

                setRecords(response.data)
            }


        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setRecordsd([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
    }

    const cancelar = () => {

        blanquear();
        props.onHideCancela();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarCuentaContable()
            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Cuenta Contables.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idcuentacontable} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "100px", verticalAlign: "middle" }}>{item.codigocuenta}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "300px", verticalAlign: "middle" }}>{item.descripcion}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "80px", verticalAlign: "middle" }}>{item.idcuentacontable}</td>

                                        {/* <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarProveedors(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td> */}
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} onClick={seleccionarLista()}><i className="fas fa-check-circle"> Aceptar</i> </button>

                <button ref={btnCancela} onClick={cancelar} className="btn btn-danger rounded-pill btn-sm"><i className="fa"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoContable;